<template>
    <app-content class="h-panel">
        <div class="h-panel-bar"><span class="h-panel-title">五险一金设置</span></div>
        <div class="margin-top margin-left filter-bar">
            <Button color="primary" size="s" @click="add">新增</Button>
            <span class="flex-spacer"></span>
            <span class="tip">系统默认提供养老/医疗/工伤/失业/公积金五项，可修改缴存基数与比例。</span>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th>项目</th>
                    <th class="num">缴存基数(元)</th>
                    <th class="num">公司比例(%)</th>
                    <th class="num">公司金额(元)</th>
                    <th class="num">个人比例(%)</th>
                    <th class="num">个人金额(元)</th>
                    <th style="width:90px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td>{{item.project}}</td>
                    <td class="num">{{item.baseAmount|numFormat}}</td>
                    <td class="num">{{item.companyRatio|numFormat}}</td>
                    <td class="num">{{item.companyAmount|numFormat}}</td>
                    <td class="num">{{item.personalRatio|numFormat}}</td>
                    <td class="num">{{item.personalAmount|numFormat}}</td>
                    <td class="actions"><span @click="edit(item)">编辑</span><span @click="remove(item)">删除</span></td>
                </tr>
                <tr v-if="!datas.length"><td :colspan="7" class="text-center padding">暂无数据</td></tr>
                <tr class="total" v-if="datas.length">
                    <td>合计</td>
                    <td></td>
                    <td></td>
                    <td class="num">{{sum('companyAmount')|numFormat}}</td>
                    <td></td>
                    <td class="num">{{sum('personalAmount')|numFormat}}</td>
                    <td></td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" hasCloseIcon>
            <div slot="header">{{form.id?'编辑五险一金':'新增五险一金'}}</div>
            <Form v-width="420" :labelWidth="120" :model="form">
                <FormItem label="项目"><input type="text" v-model="form.project"></FormItem>
                <FormItem label="缴存基数(元)"><NumberInput v-model="form.baseAmount" :precision="2" :min="0" @change="calc"></NumberInput></FormItem>
                <FormItem label="公司比例(%)"><NumberInput v-model="form.companyRatio" :precision="3" :min="0" @change="calc"></NumberInput></FormItem>
                <FormItem label="公司金额(元)"><NumberInput v-model="form.companyAmount" :precision="2" :min="0" readonly></NumberInput></FormItem>
                <FormItem label="个人比例(%)"><NumberInput v-model="form.personalRatio" :precision="3" :min="0" @change="calc"></NumberInput></FormItem>
                <FormItem label="个人金额(元)"><NumberInput v-model="form.personalAmount" :precision="2" :min="0" readonly></NumberInput></FormItem>
                <FormItem label="排序"><NumberInput v-model="form.sortNo" :min="0"></NumberInput></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button @click="showForm=false">取消</Button>
                <Button color="primary" @click="save" :loading="loading">保存</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
export default {
    name: 'SalaryInsurance',
    data() {
        return {
            datas: [], showForm: false, loading: false,
            form: this.emptyForm()
        };
    },
    methods: {
        emptyForm() { return { id: null, project: '', baseAmount: 0, companyRatio: 0, companyAmount: 0, personalRatio: 0, personalAmount: 0, sortNo: 0 }; },
        sum(f) { return this.datas.reduce((s, d) => s + Number(d[f] || 0), 0); },
        loadList() { this.$api.salary.insurance.list().then(({ data }) => { this.datas = data || []; }); },
        add() { this.form = this.emptyForm(); this.showForm = true; },
        edit(item) { this.form = Object.assign(this.emptyForm(), item); this.showForm = true; },
        remove(item) {
            this.$Confirm('确认删除?').then(() => {
                this.$api.salary.insurance.delete(item.id).then(() => { this.loadList(); this.$Message.success('已删除'); });
            });
        },
        calc() {
            this.form.companyAmount = Number((this.form.baseAmount || 0) * (this.form.companyRatio || 0) / 100).toFixed(2) * 1;
            this.form.personalAmount = Number((this.form.baseAmount || 0) * (this.form.personalRatio || 0) / 100).toFixed(2) * 1;
        },
        save() {
            if (!this.form.project) { this.$Message.error('请填写项目'); return; }
            this.calc();
            const p = Object.assign({}, this.form);
            this.loading = true;
            this.$api.salary.insurance[p.id ? 'update' : 'save'](p).then(() => {
                this.loading = false; this.showForm = false; this.loadList(); this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        }
    },
    mounted() { this.loadList(); }
};
</script>

<style scoped lang="less">
.filter-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding-bottom: 6px;
    .flex-spacer { flex: 1; }
    .tip { color: #999; font-size: 12px; }
}
.grid { width: 100%; border-collapse: collapse; margin-top: 10px;
    th, td { padding: 0 8px; border: 1px solid #e2e2e2; font-size: 12px; height: 32px; white-space: nowrap; }
    th { background-color: #f5f5f5; text-align: center; font-weight: bold; height: 35px; }
    .num { text-align: right; }
    tbody tr:nth-child(even) { background-color: #fafafa; }
    tbody tr:hover { background-color: #f0f6ff; }
    .total td { background-color: #f5f5f5; font-weight: bold; }
}
.actions span { margin-right: 8px; cursor: pointer; color: #3b91ff; }
</style>
